import { AppDispatch, RootState } from 'redux/store'
import {
  SET_SIGN_UP_MODAL_IS_OPEN,
  SET_FREE_TRIAL_REQUEST_MODAL_IS_OPEN,
  SET_USER_ROLES_MODAL_IS_OPEN,
  SET_USER_ROLES_MODAL_IS_BASIC_MESSAGE,
  SET_SHOW_SIGN_UP_MODAL_ON_CLOSE,
  SET_AOL_PREFERENCE_MODAL_OPEN,
  SET_AOL_PREFERENCE_MODAL_DISMISSED_FOR_SESSION
} from './types'

export const setSignUpModalIsOpen = (isOpen: boolean): { type: typeof SET_SIGN_UP_MODAL_IS_OPEN, isOpen: boolean } => ({
  type: SET_SIGN_UP_MODAL_IS_OPEN,
  isOpen
})

export const setFreeTrialRequestModalIsOpen = (isOpen: boolean): (dispatch: AppDispatch, getState: () => RootState) => void => (dispatch: AppDispatch, getState: () => RootState) => {
  dispatch({
    type: SET_FREE_TRIAL_REQUEST_MODAL_IS_OPEN,
    isOpen
  })
  const { modals: { freeTrialRequest: { showSignUpModalOnClose } } } = getState()
  if (!isOpen && showSignUpModalOnClose) {
    dispatch(setSignUpModalIsOpen(true))
  }
}

export const setUserRolesModalIsOpen = (isOpen: boolean): { type: typeof SET_USER_ROLES_MODAL_IS_OPEN, isOpen: boolean } => ({
  type: SET_USER_ROLES_MODAL_IS_OPEN,
  isOpen
})

export const setUserRolesModalIsBasicMessage = (isBasicMessage: boolean): { type: typeof SET_USER_ROLES_MODAL_IS_BASIC_MESSAGE, isBasicMessage: boolean } => ({
  type: SET_USER_ROLES_MODAL_IS_BASIC_MESSAGE,
  isBasicMessage
})

export const setShowSignUpModalOnFreeTrialModalClose = (showSignUpModal: boolean): { type: typeof SET_SHOW_SIGN_UP_MODAL_ON_CLOSE, showSignUpModalOnClose: boolean } => ({
  type: SET_SHOW_SIGN_UP_MODAL_ON_CLOSE,
  showSignUpModalOnClose: showSignUpModal
})

export const setAoLPreferenceModalOpen = (isOpen: boolean): { type: typeof SET_AOL_PREFERENCE_MODAL_OPEN, isOpen: boolean } => ({
  type: SET_AOL_PREFERENCE_MODAL_OPEN,
  isOpen
})

// Lets the user into the site for the rest of this session when saving preferences
// fails (e.g. the API is unreachable) instead of leaving them stuck behind a modal
// they can't dismiss. primaryAolSetByUser stays false server-side, so a fresh login
// re-fetches it and asks again - this only suppresses the modal for the current session.
export const setAoLPreferenceModalDismissedForSession = (): { type: typeof SET_AOL_PREFERENCE_MODAL_DISMISSED_FOR_SESSION } => ({
  type: SET_AOL_PREFERENCE_MODAL_DISMISSED_FOR_SESSION
})
